import { render, staticRenderFns } from "./ModalDepositsPurchase.vue?vue&type=template&id=50537ef7"
import script from "./ModalDepositsPurchase.vue?vue&type=script&lang=js"
export * from "./ModalDepositsPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports